module.exports = __webpack_public_path__ + "media/components/src/assets/images/heading_with_sub/heading_with_sub_4-8bfb4830670cec7057c6e390ef29c1f9.png";